exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".RouteRow-8d195f64{padding-left:20px;padding-right:20px;padding-bottom:5px;padding-top:5px;display:flex;flex-direction:column;border-bottom:1px solid #eee}.RouteRow-8d195f64 .row-d0a192b2{margin:0 0;padding:0 0;display:flex;flex-direction:row}.RouteRow-8d195f64 .row-d0a192b2>*{margin-right:15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.RouteRow-8d195f64 .row-d0a192b2>*:last-child{margin-right:0}.routeName-c22268d1{font-size:16px}.routeColor-b20cb43d{flex:0 1 auto;font-size:13px;width:90px}.routeUrl-b0492098{flex:1 1 auto;font-size:13px}.routeEdit-43625321{flex:0 1 auto;font-size:13px;font-weight:500}.Color-44ae1bb1{font-size:13px}.ColorSample-a839fbf6{height:1em;width:1em;display:inline-block;vertical-align:middle;border-radius:2px;margin-right:5px}\n", ""]);

// Exports
exports.locals = {
	"RouteRow": "RouteRow-8d195f64",
	"row": "row-d0a192b2",
	"routeName": "routeName-c22268d1",
	"routeColor": "routeColor-b20cb43d",
	"routeUrl": "routeUrl-b0492098",
	"routeEdit": "routeEdit-43625321",
	"Color": "Color-44ae1bb1",
	"ColorSample": "ColorSample-a839fbf6"
};